<template>
    <div class="user-list-container">
        <div 
            class="search-bar" 
            :class="{active:searchFieldActive}" @click="setSearchField"
            v-click-outside="unsetSearchField"
        >
            <div class="search-container">
                <div class="search-icon">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="path-1-inside-1_4075_209" fill="white">
                        <path d="M15.1044 15.1024C14.9784 15.2285 14.8288 15.3285 14.6641 15.3967C14.4995 15.4649 14.323 15.5 14.1447 15.5C13.9665 15.5 13.79 15.4649 13.6254 15.3967C13.4607 15.3285 13.3111 15.2285 13.1851 15.1024L9.13789 11.0562C8.87804 11.2138 8.60574 11.3499 8.32371 11.4632C7.10672 11.9552 5.75699 12.0114 4.50328 11.6223C3.24956 11.2332 2.16898 10.4227 1.44464 9.3281C0.72031 8.23355 0.396786 6.92228 0.528898 5.61651C0.661011 4.31075 1.24063 3.09081 2.16954 2.16344C3.09844 1.23608 4.31949 0.658319 5.62575 0.528086C6.93201 0.397855 8.24313 0.723158 9.33692 1.44887C10.4307 2.17458 11.2399 3.25605 11.6273 4.51002C12.0148 5.76398 11.9566 7.11331 11.4628 8.32932C11.3498 8.60906 11.2136 8.87887 11.0557 9.1359L15.1044 13.1829C15.3578 13.4375 15.5 13.782 15.5 14.1412C15.5 14.5003 15.3578 14.8449 15.1044 15.0995M2.98193 9.38972C3.72332 10.1311 4.69889 10.5924 5.7424 10.6953C6.78591 10.7981 7.83279 10.5359 8.70466 9.95353C9.57652 9.37113 10.2194 8.5045 10.5238 7.50132C10.8281 6.49813 10.7751 5.42047 10.3738 4.45198C9.97249 3.48348 9.24767 2.68408 8.32287 2.18999C7.39807 1.6959 6.33052 1.5377 5.30213 1.74235C4.27373 1.947 3.34814 2.50183 2.68307 3.3123C2.018 4.12277 1.65461 5.13873 1.65482 6.18704C1.65498 7.38829 2.13234 8.54029 2.98193 9.38972Z"/>
                        </mask>
                        <path d="M15.1044 15.1024C14.9784 15.2285 14.8288 15.3285 14.6641 15.3967C14.4995 15.4649 14.323 15.5 14.1447 15.5C13.9665 15.5 13.79 15.4649 13.6254 15.3967C13.4607 15.3285 13.3111 15.2285 13.1851 15.1024L9.13789 11.0562C8.87804 11.2138 8.60574 11.3499 8.32371 11.4632C7.10672 11.9552 5.75699 12.0114 4.50328 11.6223C3.24956 11.2332 2.16898 10.4227 1.44464 9.3281C0.72031 8.23355 0.396786 6.92228 0.528898 5.61651C0.661011 4.31075 1.24063 3.09081 2.16954 2.16344C3.09844 1.23608 4.31949 0.658319 5.62575 0.528086C6.93201 0.397855 8.24313 0.723158 9.33692 1.44887C10.4307 2.17458 11.2399 3.25605 11.6273 4.51002C12.0148 5.76398 11.9566 7.11331 11.4628 8.32932C11.3498 8.60906 11.2136 8.87887 11.0557 9.1359L15.1044 13.1829C15.3578 13.4375 15.5 13.782 15.5 14.1412C15.5 14.5003 15.3578 14.8449 15.1044 15.0995M2.98193 9.38972C3.72332 10.1311 4.69889 10.5924 5.7424 10.6953C6.78591 10.7981 7.83279 10.5359 8.70466 9.95353C9.57652 9.37113 10.2194 8.5045 10.5238 7.50132C10.8281 6.49813 10.7751 5.42047 10.3738 4.45198C9.97249 3.48348 9.24767 2.68408 8.32287 2.18999C7.39807 1.6959 6.33052 1.5377 5.30213 1.74235C4.27373 1.947 3.34814 2.50183 2.68307 3.3123C2.018 4.12277 1.65461 5.13873 1.65482 6.18704C1.65498 7.38829 2.13234 8.54029 2.98193 9.38972Z" fill="#7D7D7D"/>
                        <path d="M14.1447 15.5L14.1447 16.5L14.1447 15.5ZM13.1851 15.1024L13.8923 14.3955L13.8921 14.3953L13.1851 15.1024ZM9.13789 11.0562L9.84492 10.349L9.2901 9.7943L8.6193 10.2012L9.13789 11.0562ZM8.32371 11.4632L7.95103 10.5352L7.94889 10.5361L8.32371 11.4632ZM11.4628 8.32932L10.5362 7.95303L10.5355 7.95492L11.4628 8.32932ZM11.0557 9.1359L10.2037 8.61231L9.79029 9.28498L10.3487 9.84316L11.0557 9.1359ZM15.1044 13.1829L15.8132 12.4775L15.8113 12.4757L15.1044 13.1829ZM15.5 14.1412L16.5 14.1412L15.5 14.1412ZM1.65482 6.18704L2.65482 6.18691L2.65482 6.18684L1.65482 6.18704ZM14.3971 14.3955C14.364 14.4286 14.3247 14.4549 14.2814 14.4728L15.0469 16.3205C15.3329 16.202 15.5927 16.0284 15.8116 15.8094L14.3971 14.3955ZM14.2814 14.4728C14.2381 14.4908 14.1916 14.5 14.1447 14.5L14.1447 16.5C14.4543 16.5 14.7609 16.439 15.0469 16.3205L14.2814 14.4728ZM14.1447 14.5C14.0979 14.5 14.0514 14.4908 14.0081 14.4728L13.2426 16.3205C13.5286 16.439 13.8352 16.5 14.1447 16.5L14.1447 14.5ZM14.0081 14.4728C13.9648 14.4549 13.9255 14.4286 13.8923 14.3955L12.4779 15.8094C12.6968 16.0284 12.9566 16.202 13.2426 16.3205L14.0081 14.4728ZM13.8921 14.3953L9.84492 10.349L8.43087 11.7634L12.4781 15.8096L13.8921 14.3953ZM8.6193 10.2012C8.40602 10.3305 8.18252 10.4422 7.95103 10.5352L8.6964 12.3911C9.02897 12.2576 9.35007 12.0971 9.65649 11.9112L8.6193 10.2012ZM7.94889 10.5361C6.94573 10.9416 5.83314 10.988 4.7997 10.6672L4.20685 12.5774C5.68084 13.0348 7.2677 12.9687 8.69853 12.3903L7.94889 10.5361ZM4.7997 10.6672C3.76626 10.3465 2.87559 9.6784 2.27858 8.77624L0.610709 9.87997C1.46236 11.1669 2.73286 12.1199 4.20685 12.5774L4.7997 10.6672ZM2.27858 8.77624C1.68157 7.87409 1.41494 6.79335 1.52382 5.71718L-0.466022 5.51585C-0.621363 7.0512 -0.240951 8.593 0.610709 9.87997L2.27858 8.77624ZM1.52382 5.71718C1.6327 4.641 2.11042 3.63551 2.87606 2.87114L1.46301 1.45575C0.370849 2.54611 -0.310682 3.9805 -0.466022 5.51585L1.52382 5.71718ZM2.87606 2.87114C3.6417 2.10675 4.64819 1.63051 5.72495 1.52315L5.52654 -0.46698C3.99079 -0.313868 2.55518 0.365396 1.46301 1.45575L2.87606 2.87114ZM5.72495 1.52315C6.80172 1.4158 7.88248 1.68396 8.78406 2.28214L9.88978 0.615593C8.60378 -0.237643 7.06229 -0.620093 5.52654 -0.46698L5.72495 1.52315ZM8.78406 2.28214C9.68564 2.88032 10.3526 3.77171 10.6719 4.80522L12.5828 4.21482C12.1272 2.74039 11.1758 1.46883 9.88978 0.615593L8.78406 2.28214ZM10.6719 4.80522C10.9912 5.83872 10.9433 6.9508 10.5363 7.95303L12.3893 8.7056C12.9699 7.27581 13.0383 5.68925 12.5828 4.21482L10.6719 4.80522ZM10.5355 7.95492C10.4434 8.18292 10.3324 8.40281 10.2037 8.61231L11.9076 9.6595C12.0948 9.35492 12.2562 9.03521 12.39 8.70371L10.5355 7.95492ZM10.3487 9.84316L14.3974 13.8902L15.8113 12.4757L11.7626 8.42865L10.3487 9.84316ZM14.3956 13.8883C14.4625 13.9556 14.5 14.0465 14.5 14.1412L16.5 14.1412C16.5 13.5176 16.253 12.9195 15.8132 12.4775L14.3956 13.8883ZM14.5 14.1412C14.5 14.2359 14.4625 14.3268 14.3956 14.3941L15.8132 15.8049C16.253 15.3629 16.5 14.7648 16.5 14.1412L14.5 14.1412ZM2.27485 10.0968C3.17984 11.0018 4.37065 11.5649 5.64435 11.6904L5.84044 9.70007C5.02712 9.61994 4.2668 9.26034 3.68902 8.68259L2.27485 10.0968ZM5.64435 11.6904C6.91805 11.8159 8.19589 11.496 9.26012 10.7851L8.14919 9.12199C7.4697 9.57589 6.65377 9.7802 5.84044 9.70007L5.64435 11.6904ZM9.26012 10.7851C10.3244 10.0742 11.1091 9.01628 11.4807 7.79165L9.56684 7.21099C9.32966 7.99272 8.82868 8.6681 8.14919 9.12199L9.26012 10.7851ZM11.4807 7.79165C11.8522 6.56701 11.7875 5.25145 11.2976 4.06916L9.44999 4.83479C9.76272 5.5895 9.80401 6.42926 9.56684 7.21099L11.4807 7.79165ZM11.2976 4.06916C10.8077 2.88688 9.92294 1.91108 8.7941 1.30798L7.85164 3.072C8.5724 3.45708 9.13725 4.08008 9.44999 4.83479L11.2976 4.06916ZM8.7941 1.30798C7.66527 0.704881 6.36221 0.511789 5.10695 0.761582L5.4973 2.72312C6.29883 2.56362 7.13088 2.68692 7.85164 3.072L8.7941 1.30798ZM5.10695 0.761582C3.8517 1.01138 2.72187 1.68861 1.91003 2.67795L3.45611 3.94666C3.9744 3.31505 4.69577 2.88262 5.4973 2.72312L5.10695 0.761582ZM1.91003 2.67795C1.09818 3.66728 0.65456 4.9075 0.654817 6.18725L2.65482 6.18684C2.65465 5.36996 2.93782 4.57826 3.45611 3.94666L1.91003 2.67795ZM0.654817 6.18718C0.655012 7.65366 1.23778 9.05999 2.2749 10.0969L3.68897 8.68255C3.0269 8.0206 2.65494 7.12292 2.65482 6.18691L0.654817 6.18718Z" fill="#7D7D7D" mask="url(#path-1-inside-1_4075_209)"/>
                    </svg>
                </div>
                <input v-if="searchFieldActive" ref="searchField" type="text" class="search-input" placeholder="Ieškoti" v-model="searchString" @input="searchUsers">
            </div>
            <div class="user-count">
                <font-awesome-icon icon="spinner" v-if="isLoadingUsers"/>
                <span class="user-count-label" v-if="!isLoadingUsers">
                    {{ toLocal('users.user_count') }}
                </span>
                {{ isLoadingUsers ? '' : ': ' + usersCopy.length }}
            </div>
        </div>
        <div class="user-list" v-if="!isLoadingUsers">
            <div 
                class="user" 
                v-for="(user, index) in usersCopy" 
                :key="index"
                :class="{selected: selectedUser.id == user.id}"
                @click="selectUser(user)"
             >
                <div class="invite-container" v-if="user.new_user">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3194 0C14.5743 0 14.781 0.209446 14.781 0.467812V7.08006C14.781 7.33842 14.5743 7.54787 14.3194 7.54787C14.0645 7.54787 13.8578 7.33842 13.8578 7.08006V0.467812C13.8578 0.209446 14.0645 0 14.3194 0Z" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18 3.84942C18 4.10779 17.7933 4.31723 17.5384 4.31723L10.9542 4.31723C10.6992 4.31723 10.4925 4.10779 10.4925 3.84942C10.4925 3.59106 10.6992 3.38161 10.9542 3.38161L17.5384 3.38161C17.7933 3.38161 18 3.59106 18 3.84942Z" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.57715 6.77478C1.18124 6.77478 0.860288 7.09745 0.860288 7.4955V7.83451L5.80273 10.9921L5.80371 10.9927C5.91209 11.0607 6.03729 11.0968 6.16506 11.0968C6.29283 11.0968 6.41803 11.0607 6.52641 10.9927L6.52739 10.9921L11.4698 7.83451V7.4955C11.4698 7.09745 11.1489 6.77478 10.753 6.77478H1.57715ZM12.3301 8.06476V7.4955C12.3301 6.6198 11.624 5.90991 10.753 5.90991H1.57715C0.706144 5.90991 5.45298e-05 6.6198 5.45298e-05 7.4955V8.06478C-1.8245e-05 8.06937 -1.81082e-05 8.07396 5.45298e-05 8.07855V14.4144C5.45298e-05 15.2901 0.706144 16 1.57715 16H10.753C11.624 16 12.3301 15.2901 12.3301 14.4144V8.07857C12.3301 8.07397 12.3301 8.06936 12.3301 8.06476ZM11.4698 8.85922L6.98412 11.725C6.73862 11.8797 6.45477 11.9617 6.16506 11.9617C5.87536 11.9617 5.59151 11.8797 5.34601 11.725L5.34368 11.7235L0.860288 8.85922V14.4144C0.860288 14.8125 1.18124 15.1351 1.57715 15.1351H10.753C11.1489 15.1351 11.4698 14.8125 11.4698 14.4144V8.85922Z" fill="white"/>
                    </svg>

                </div>
                <div class="user-tab">
                    <span class="user-name">
                        {{ getUserFullName(user) }}
                    </span>
                    <div class="user-rating" :style="{'font-size': user.user_rating == 100 ? '8px' : '10px'}">
                        {{ getUserRating(user) }}
                    </div>
                </div>
            </div>
        </div>
        <div class="user-list" v-else>
            <div class="user skeleton" v-for="n in 3" :key="n">
                <span></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        users: Array,
        selectedUser: Object,
        isLoadingUsers: Boolean
    },
    data() {
        return {
            searchString: '',
            usersCopy: [],
            searchFieldActive: false,
        }
    },
    watch: {
        'users'() {
            this.usersCopy = this._.cloneDeep(this.users);
        }
    },
    mounted() {
        this.usersCopy = this._.cloneDeep(this.users);
    },
    methods: {
        setSearchField() {
            this.searchFieldActive=true
            this.$nextTick(()=>{
                this.$refs['searchField'].focus()
            })
        },
        unsetSearchField() {
            if(this.searchString.length == 0) {
                this.searchFieldActive = false
            }
        },
        getUserFullName(user) {
            return user.name + ' ' + user.last_name
        },
        selectUser(user){
            this.$emit('selectUser', user)
            
        },
        searchUsers() {
            if(this.searchString.length == 0) {
                this.usersCopy = this._.cloneDeep(this.users);
            }
            else {
                let search = this.searchString.toLowerCase();
                this.usersCopy = this.users.filter(user => {
                    let name = user.name.toLowerCase();
                    let last_name = user.last_name ? user.last_name.toLowerCase() : null;
                    if(last_name && last_name != null)
                        return name.includes(search) || last_name.includes(search);
                    else
                        return name.includes(search);
                })
            }
        },
        getUserRating(user){
            if(isNaN(user.user_rating)){
                return '0%';
            }
            return Math.round(user.user_rating, 2)+'%';
        }
        
    }
}
</script>

<style lang="scss" scoped>
.user-list-container{
    display: flex;
    flex-direction: column;
    width: clamp(220px, 14.3vw, 230px);
    height: 100%;
    border-radius: 15px 0 0 15px;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.16);

}
.search-bar{
    padding: 6px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color:#333333;
    background-color: white;
    // border-top: 4px solid #4D4D4D;

    border-bottom: 1px solid #E2E2E2;
    border-radius: 15px 0 0 0;
    &:hover{
        .search-container{
            background-color: #F4F4F4;
        }
    }
    &.active{
        .search-container{
            width: 100%;
        }
        .user-count{
            display: none;
        }
    }
}
.search-container{
    position: relative;
    display: flex;
    border-radius: 40px;
    width: 24px;
    height: 24px;
    background-color: white;

    transition: width 0.3s ease-in-out;
}
.search-icon{
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;

    width: 24px;
    height: 24px;
    bottom: 0;
    margin: auto;
    svg{
        width: 15px;
        height: 15px;
    }
}
input{
    width: 100%;
    background-color: none;
    padding-left: 26.5px;
    border: none;
    background-color: #F4F4F4;
    border-radius: 40px;

}
.user-list{
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: white;
    border-radius: 0 0 0 15px;
    padding-top: 8px;
    max-height: 100%;
    overflow: auto;
}
.user-count{
    min-width: 40px;
    min-height: 20px;
    display: flex;
    white-space: nowrap;
    align-items: center;
    justify-content: center;
    background-color: #F4DC00;
    border-radius: 11px;
    padding: 3px 15px;
}
.user{
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
    // overflow: hidden;
    text-overflow: ellipsis;
    span{
        color: #333333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    &:hover{
        background-color: #EAEAEA;
    }
    &.selected{
        background-color: #EAEAEA;
    }
    &.skeleton{
        height: 50px;
        padding: 5px;
        &:hover{
            background-color: initial;
        }
        span{
            background-color: #EAEAEA;
            width: 100%;
            height: 100%;
            border-radius: 10px;
            animation: fadeOut 0.75s infinite;
        }
        &:nth-child(2){
            span{
                animation-delay: 0.25s;
            }
        }
        &:nth-child(3){
            span{
                animation-delay: 0.5s;
            }
        }
    }
}
.user-count-label{
    max-width: 6rem;
    overflow: hidden;
    text-overflow: ellipsis;
}
@keyframes fadeOut {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.3;
    }
    100% {
        opacity: 1;
    }
}

.invite-container{
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #4D4D4D;
    height: 100%;
    top: 0;
    padding: 0 3px;
    cursor: pointer;
    border-radius: 0 6px 6px 0;
}
.user-tab{
    display: flex;
    padding: 10px 8px;
    width: 100%;
    overflow: hidden;
    font-size: clamp(16px, 1.5vw, 18px);
    .user-name{
        width: 100%;
    }
    .user-rating{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        min-width: 24px;
        background: linear-gradient(180deg, #FDDF40 0%, #FD9B40 100%);
        border-radius: 50%;
        color: white;
        font-size: 10px;
        font-weight: medium;
    }
}
</style>